import {
  AdditionalGroupProps,
  translatedAdditionalGroupProps,
} from 'modules/additional-groups/types';
import {CategoryProps, translatedCategoryProps} from 'modules/categories/types';
import {
  CompanyProps,
  translatedCompanyProps,
  WorkingPeriodProps,
} from 'modules/companies/types';
import {CouponTypeEnum, SponsorTypeEnum} from 'modules/coupons/types';
import {
  SubCategoryProps,
  translatedSubCategoryProps,
} from 'modules/sub-categories/types';
import {TranslatedKeys} from 'shared/types/translated-keys';

export enum SaleTypeEnum {
  oneTime = 'oneTime',
  periodical = 'periodical',
}

export enum PriceModeEnum {
  fixed = 'fixed',
  size = 'size',
  additionals = 'additionals',
}

export enum AdditionalGroupConfigTypeEnum {
  sum = 'sum',
  average = 'average',
  highest_value = 'highest_value',
}

export type AdditionalPriceWhenFree = {
  id: string;
  price: number;
};

export interface AdditionalGroupConfigProps {
  id: string;
  additionalGroupId: string;
  productId: string;
  min: number;
  max: number;
  isFree: boolean;
  additionalGroup: AdditionalGroupProps;
  product: ProductProps;
  type: AdditionalGroupConfigTypeEnum;
  additionalPricesWhenFree: AdditionalPriceWhenFree[];
}

export interface SizeProps {
  id: string;
  name: string;
  price: number;
  sale: SaleProps[];
  salePrice?: number;
  saleId?: string;
  remainingProducts?: number;
  onePerOrder?: boolean;
  sales: SaleProps[];
}

export interface ProductProps {
  id: string;
  name: string;
  description: string;
  active: boolean;
  categoryId: string;
  categoryName: string;
  category: CategoryProps;
  companyId: string;
  companyName: string;
  cityId: string;
  cityName: string;
  company: CompanyProps;
  priceMode: PriceModeEnum;
  price: number;
  sale: SaleProps[];
  image?: string;
  sizes: SizeProps[];
  additionalGroupsConfig: AdditionalGroupConfigProps[];
  subCategory?: SubCategoryProps;
  subCategoryId?: string;
  minPrice?: number;
  workingPeriods: WorkingPeriodProps[];
  salePrice?: number;
  saleId?: string;
  remainingProducts?: number;
  onePerOrder?: boolean;
}

export const translatedProductProps: TranslatedKeys<ProductProps> = {
  name: 'Nome',
  description: 'Descrição',
  active: 'Ativo?',
  categoryId: 'Categoria',
  categoryName: 'Categoria',
  category: {...translatedCategoryProps, name: 'Categoria'},
  companyId: 'Empresa',
  company: {...translatedCompanyProps, name: 'Empresa'},
  priceMode: 'Tipo de preço',
  price: 'Preço',
  sale: 'Promoções',
  image: 'Imagem',
  sizes: 'Tamanhos',
  additionalGroupsConfig: 'Configuração de grupos de adicionais',
  subCategoryId: 'Sub categoria',
  subCategory: {...translatedSubCategoryProps, name: 'Sub categoria'},
  minPrice: 'A partir de',
  workingPeriods: 'Horários de funcionamento',
  cityId: 'Cidade',
  cityName: 'Cidade',
  companyName: 'Empresa',
};

export interface SaleProps {
  id: string;
  product: ProductProps;
  productId?: string;
  size: SizeProps;
  sizeId?: string;
  days?: string[];
  date?: string;
  value: number;
  active: boolean;
  type: SaleTypeEnum;
  valueType: CouponTypeEnum;
  sponsorType: SponsorTypeEnum;
  onePerOrder?: boolean;
  onePerCustomer?: boolean;
  numberOfProducts?: number;
  remainingProducts?: number;
}

export const translatedSizeProps: TranslatedKeys<SizeProps> = {
  name: 'Nome',
  price: 'Preço',
  sale: 'Promoção',
  sales: 'Promoções',
};

export const translatedAdditionalGroupConfigProps: TranslatedKeys<AdditionalGroupConfigProps> =
  {
    isFree: 'Grátis?',
    min: 'Mínimo',
    max: 'Máximo',
    additionalGroupId: 'Grupo de adicionais',
    additionalGroup: {
      ...translatedAdditionalGroupProps,
      name: 'Grupo de adicionais',
    },
    productId: 'Produto',
    product: {...translatedProductProps, name: 'Produto'},
    type: 'Tipo',
    additionalPricesWhenFree: 'Preços grátis',
  };

export const translatedSaleProps: TranslatedKeys<SaleProps> = {
  active: 'Ativo?',
  product: translatedProductProps,
  size: {...translatedSizeProps, name: 'Tamanho'},
  type: 'Tipo',
  valueType: 'Tipo do valor',
  value: 'Valor/porcentagem',
  date: 'Data',
  days: 'Dias',
  productId: 'Produto',
  sizeId: 'Tamanho',
  sponsorType: 'Patrocinador',
  onePerOrder: 'Um uso por pedido?',
  onePerCustomer: 'Uma compra por cliente?',
  numberOfProducts: 'Quantidade de produtos',
  remainingProducts: 'Produtos restantes',
};
